<!-- 备件库弹窗 -->
<template>
  <z-popup v-model="sparePartsShow" position="bottom" @click-overlay="closePopup">
    <div class="spare-parts-wrapper">
      <div class="header">
        <span class="title">{{ sourceInfo.title }}</span>
        <img
          src="https://pic4.zhuanstatic.com/zhuanzh/d3e99a56-a5c1-4600-92fc-75ade87d7081.png"
          alt=""
          @click="closePopup"
        />
      </div>
      <div class="spare-parts_desc">{{ sourceInfo.describe }}</div>
      <source-info ref="biz" :dataInfo="dataInfo" :visibilityState="visibilityState" />

      <div class="footer" @click="closePopup">我知道了</div>
    </div>
  </z-popup>
</template>

<script>
import { Popup, Dialog } from '@zz-common/zz-ui'
import Vue from 'vue'
import sourceInfo from '../sourceInfo/index.vue'
import { defineComponent, watch, ref } from '@vue/composition-api'
Vue.use(Popup).use(Dialog)

export default defineComponent({
  components: {
    sourceInfo
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    sourceInfo: {
      type: Object,
      default: () => {}
    },
    dataInfo: {
      type: Object,
      default: () => {}
    },
    visibilityState: {
      type: String,
      default: ''
    }
  },
  setup(props, ctx) {
    const { $legoSend } = ctx.root
    const sparePartsShow = ref(false)
    const biz = ref(null)
    const closePopup = () => {
      biz.value.$refs.refVideo.$refs.video.pause()
      sparePartsShow.value = false
    }

    watch(
      () => sparePartsShow.value,
      (val) => {
        if (val) {
          $legoSend({
            pagetype: 'Areaexposure',
            actiontype: 'T2974',
            backup: {
              sectionId: 144
            }
          })
        }
      }
    )
    return { sparePartsShow, biz, closePopup }
  }
})
</script>

<style lang="scss" scoped>
@import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
.spare-parts-wrapper {
  padding: 24px 32px;
  .header {
    position: relative;
    width: 100%;
    height: 80px;
    color: #111111;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    .title {
      display: inline-block;
      width: 100%;
      line-height: 80px;
      text-align: center;
    }

    img {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      margin-top: 20px;
      margin-right: -8px;
    }
  }
  .spare-parts_desc {
    color: #111111;
    font-weight: 300;
    font-size: 26px;
    font-family: PingFangSC-Light, PingFang SC;
    line-height: 40px;
  }
  .footer {
    width: 100%;
    height: 80px;
    margin-top: 268px;
    color: #ffffff;
    font-weight: 500;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    line-height: 80px;
    text-align: center;
    background: #ff483c;
    border-radius: 40px;
  }
}
</style>
